import { ActivityStatus } from '@/domain/happiness-level/entity/activity-happiness.entity';
import ActivityFile from './activity-file.entity';

export default class AuditHomeTime {
  activityId: string;

  activityName: string;

  employeeName: string;

  executedByName: string;

  status: string;

  employeeAdmissionDate: string;

  employeeDb1StartDate: string;

  expectedDate: string;

  observation: string;

  files: ActivityFile[];

  constructor(obj: any = {}) {
    this.activityId = obj.activityId || '';
    this.activityName = obj.activityName || '';
    this.employeeName = obj.employeeName || '';
    this.executedByName = obj.executedByName || '';
    this.status = obj.status || 'Pendente';
    this.employeeAdmissionDate = obj.employeeAdmissionDate || '';
    this.employeeDb1StartDate = obj.employeeDb1StartDate || this.employeeAdmissionDate;
    this.expectedDate = obj.expectedDate || '';
    this.observation = obj.observation || '';
    this.files = obj.files ? ActivityFile.ofList(obj.files) : [];
  }

  get statusColor() {
    switch (this.status) {
      case 'Aprovada':
        return 'success';
      case 'Recusada':
        return 'error';
      default:
        return 'warning';
    }
  }

  get db1StartDateFormatted() {
    return this.employeeDb1StartDate ? new Date(this.employeeDb1StartDate).toLocaleDateString() : '';
  }
}
